import { FC } from "react";
import { Stack } from "@mui/material";
import { UtilizationAndCoverageGaugeChartCard } from "./UtilizationAndCoverageGaugeChartCard";
import { useAppSelector } from "../../../../../../../../store/hooks";
import { savingsPlansGranularDataTotalCommitmentSelector } from "../../../../../../../../store/commitments/selectors/coverage-and-utilization/data/granular/totals/savingsPlansGranularDataTotalCommitmentSelector";
import { savingsPlansGranularDataTotalCoverageSelector } from "../../../../../../../../store/commitments/selectors/coverage-and-utilization/data/granular/totals/savingsPlansGranularDataTotalCoverageSelector";
import { savingsPlansGranularDataTotalUtilizationSelector } from "../../../../../../../../store/commitments/selectors/coverage-and-utilization/data/granular/totals/savingsPlansGranularDataTotalUtilizationSelector";
import { savingsPlansGranularDataUncoveredUsageSelector } from "../../../../../../../../store/commitments/selectors/coverage-and-utilization/data/granular/totals/savingsPlansGranularDataUncoveredUsageSelector";
import { commitmentsForGranularLoadingSelector } from "../../../../../../../../store/commitments/selectors/coverage-and-utilization/data/loading/commitmentsForGranularLoadingSelector";
import { utilizationAndCoverageChartTypeSelector } from "../../../../../../../../store/commitments/selectors/coverage-and-utilization/view-options/utilizationAndCoverageChartTypeSelector";
import { UtilizationAndCoverageChartTypeSelect } from "../../UtilizationAndCoverageChartTypeSelect";

export const UtilizationAndCoverageGaugeChart: FC = () => {
  const totalCommitment = useAppSelector(
    savingsPlansGranularDataTotalCommitmentSelector,
  );
  const totalCoverage = useAppSelector(
    savingsPlansGranularDataTotalCoverageSelector,
  );
  const totalUtilization = useAppSelector(
    savingsPlansGranularDataTotalUtilizationSelector,
  );
  const uncoveredUsage = useAppSelector(
    savingsPlansGranularDataUncoveredUsageSelector,
  );
  const loading = useAppSelector(commitmentsForGranularLoadingSelector);

  const contentView = useAppSelector(utilizationAndCoverageChartTypeSelector);

  if (contentView !== "gauge") {
    return null;
  }

  return (
    <Stack spacing={1}>
      <UtilizationAndCoverageChartTypeSelect />

      <Stack direction="row" spacing={2}>
        <UtilizationAndCoverageGaugeChartCard
          title="Utilization"
          loading={loading}
          primary={{
            label: "Utilization",
            value: totalUtilization?.amount,
            percent: totalUtilization?.percent,
          }}
          secondary={{
            label: "Commitment",
            value: totalCommitment,
          }}
        />

        <UtilizationAndCoverageGaugeChartCard
          title="Coverage"
          loading={loading}
          primary={{
            label: "Covered",
            value: totalCoverage?.amount,
            percent: totalCoverage?.percent,
          }}
          secondary={{
            label: "Not Covered (On-Demand)",
            value: uncoveredUsage,
          }}
        />
      </Stack>
    </Stack>
  );
};
